import "./Projects.scss";
import { Grid } from "@material-ui/core";
import { Text } from "sunrise-ui";
import { Pie } from "react-chartjs-2";
import FilterComponent from "../../components/helperComponents/FilterComponent";
// import { useState } from "react";

const FinancialStatus = (props: any) => {
    const { totalPaymentReceived, totalBillingDone, overallWorkDone, workOrderValue, setValue, value,resetAll } = props;
    // const [value, setValue] = useState({ from: "", to: "" });
    
   


    return (
      <Grid item lg={7} xs={12}>
        <Grid className="box--shadow project_info_card p1 h15">
          <Grid className="d-flex v-center">
          <Text
            type="normal"
            fonts="normal"
            fontSize={18}
            className="mb0 mt0 fw500 px-1"
          >
            Project Financial Status
          </Text>
          <Grid>
                  <FilterComponent
                    handleFilterDate={props.handleFilterDate}
                    setValue={setValue}
                    value={value}
                    resetAll={resetAll}
                  />
          </Grid>
          </Grid>
          <Grid container>
            <Grid
              item
              xs={6}
              className="pie_chart_box_container d-flex h-center v-center"
            >
              <Grid className="pie_chart_box">
                <Pie
                  data={{
                    //labels: ["Remaining Work Order Value", "Total Billing done", "Overall Work Done", "Total Payment Recieved",],
                    datasets: [
                      {
                        label: "# project financial status",
                        data: [
                          totalPaymentReceived,
                          totalBillingDone,
                          overallWorkDone,
                          workOrderValue,
                        ],
                        backgroundColor: [
                          "#5F67E0",
                          "#FFCD4C",
                          "#FFF597",
                          "#3C43A6",
                        ],
                      },
                    ],
                  }}
                />
              </Grid>
            </Grid>
            <Grid item xs={6} className="scrollFina mr-2">
              <Text
                type="normal"
                fonts="normal"
                fontSize={16}
                className="mb mt0 fw500"
              >
                <span> Financial Parameter</span>
                <span className="float-right"> Amount</span>
              </Text>
              <Text
                type="normal"
                fonts="normal"
                fontSize={16}
                className="mb1 mt0 fw400"
              >
                <span>Total Payment Received:</span>
                <span className="float-right">
                  {" "}
                  Rs {Math.round(totalPaymentReceived)}
                </span>
              </Text>
              <Text
                type="normal"
                fonts="normal"
                fontSize={16}
                className="mb1 mt0 fw400"
              >
                <span>Total Billing Done:</span>
                <span className="float-right">
                  {" "}
                  Rs {Math.round(totalBillingDone)}
                </span>
              </Text>
              <Text
                type="normal"
                fonts="normal"
                fontSize={16}
                className="mb1 mt0 fw400"
              >
                <span>Overall Work Done:</span>
                <span className="float-right">
                  {" "}
                  Rs {Math.round(overallWorkDone)}
                </span>
              </Text>
              <Text
                type="normal"
                fonts="normal"
                fontSize={16}
                className="mb1 mt0 fw400"
              >
                <span>Work Order Value:</span>
                <span className="float-right">
                  Rs { Math.round(workOrderValue)}
                </span>
              </Text>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
}

export default FinancialStatus;